import Header from './components/Header';
import Maps from './components/Maps';
// import './external/swiper/swiper.min.css';
// import './external/swiper/swiper.min';
// import './external/flickity/flickity.pkgd.min';
// import './external/flickity/flickity.min.css';
// import './external/icon/ionicons';

import SearchListing from "./components/SearchListing";
import MediaCenterListing from "./components/MediaCenterListing";

import './external/fancybox/fancybox.css';
import './external/fancybox/fancybox';


if (!$('.edit-mode').length) {
  require('./external/bootstrap/bootstrap.min.js');
}

import ToolTip from './components/ToolTip';
import './external/chosen/chosen.css';
import './external/chosen/chosen';
import JudgementOrdersFilters from "./components/JudgementOrdersFilters";
import AgendaMinutesFilters from "./components/AgendaMinutesFilters";
import GridListing from "./components/GridListing";

import 'daterangepicker';




export default new (class App {
  constructor() {
    this.setDomMap();
    this.previousScroll = 0;

    // dom ready shorthand
    $(() => {
      this.domReady();
    });
  }

  domReady = () => {
    this.initComponents();
    this.handleUserAgent();
    this.windowResize();
    this.bindEvents();
    this.handleSplashScreen();
    this.handleTableScroll();
    this.allTableScroll();
    this.handleRulesTabs();
    this.leftRightcontentBlock();
    this.checkBoxEvent();
    this.selectUaeEvent();

  };

  initComponents = () => {
    new Header({
      header: this.header,
      htmlBody: this.htmlBody,
    });

    if (this.mapContainer.length) {
      new Maps({
        mapContainer: this.mapContainer,
      });
    }

    if (this.searchListing.length) {
      new SearchListing(this.searchListing);
    }
    if (this.mediaCenterListing.length) {
      new MediaCenterListing(this.mediaCenterListing);
    }
    if (this.judgementOrdersListing.length) {
      new JudgementOrdersFilters(this.judgementOrdersListing);
    }
    if (this.agendaMinutesFilters.length) {
      new AgendaMinutesFilters(this.agendaMinutesFilters);
    }
    if (this.girdListing.length) {
      new GridListing(this.girdListing);
    }
    new ToolTip();
  };

  setDomMap = () => {
    this.window = $(window);
    this.htmlNbody = $('body, html');
    this.html = $('html');
    this.htmlBody = $('body');
    this.siteLoader = $('.site-loader');
    this.header = $('header');
    this.siteBody = $('.site-body');
    this.footer = $('footer');
    this.gotoTop = $('#gotoTop');
    this.gRecaptcha = $('.g-recaptcha');
    this.wrapper = $('.wrapper');
    this.pushDiv = this.wrapper.find('.push');
    this.mapContainer = $('#map_canvas');
    this.inputs = $('input, textarea').not('[type="checkbox"], [type="radio"]');
    this.searchListing = $('.search--listing');
    this.mediaCenterListing = $('.media--center--listing');
    this.judgementOrdersListing = $('.judgement--orders--listing');
    this.agendaMinutesFilters = $('.agenda--minutes--listing');
    this.girdListing = $('.grid--container');
  };

  bindEvents = () => {

    // Window Events

    this.window.resize(this.windowResize).scroll(this.windowScroll);

    // General Events
    const $container = this.wrapper;

    $container.on('click', '.disabled', () => false);

    // Specific Events
    this.gotoTop.on('click', () => {
      this.htmlNbody.animate({
        scrollTop: 0,
      });
    });

    this.inputs
      .on({
        focus: e => {
          const self = $(e.currentTarget);
          self.closest('.element').addClass('active');
          //self.closest('.elem_text').addClass('active');
        },
        blur: e => {
          const self = $(e.currentTarget);
          if (self.val() !== '') {
            self.closest('.element').addClass('active');
            //self.closest('.elem_text').addClass('active');
          } else {
            self.closest('.element').removeClass('active');
            //self.closest('.elem_text').removeClass('active');
          }
        },
      })
      .trigger('blur');

    // Reload the current path when changing language instead of redirecting to landing page
    // Uncomment below and modify languages
    // $container.on('click', '.language-toggle', function(e) {
    //   e.preventDefault();
    //   const $this = $(this);
    //   const href = $this.attr('href');
    //   const isEnglish = href.indexOf('/ar') >= 0;
    //   const locArray = location.pathname.split('/');
    //   const indexOfIndex = locArray.indexOf('index.php');
    //   const isDev = indexOfIndex >= 0;
    //   const index = isDev ? indexOfIndex + 1 : 1;
    //   if(!isEnglish) {
    //     locArray = locArray.filter(item => item !== 'ar')
    //   }
    //   locArray.splice(index, 0, isEnglish ? 'ar' : '');
    //   const newHref = locArray.join('/').replace('//', '/');
    //   location.href = newHref;
    // });

    // Uncomment below if you need to add google captcha (also in includes/script.php)
    // => Make sure the SITEKEY is changed below
    // this.gRecaptcha.each((index, el) => {
    //   grecaptcha.render(el, {'sitekey' : '6LeB3QwUAAAAADQMo87RIMbq0ZnUbPShlwCPZDTv'});
    // });
  };

  windowResize = () => {
    this.screenWidth = this.window.width();
    this.screenHeight = this.window.height();

    // calculate footer height and assign it to wrapper and push/footer div
    if (this.pushDiv.length){
      this.footerHeight = this.footer.outerHeight();
      //this.wrapper.css('margin-bottom', -this.footerHeight);
      //this.pushDiv.height(this.footerHeight);
    }
  };

  windowScroll = () => {
    const topOffset = this.window.scrollTop();

    this.header.toggleClass('top', topOffset > 300);
    this.header.toggleClass('sticky', topOffset > 600);
    if (topOffset > this.previousScroll || topOffset < 500) {
      this.header.removeClass('sticky');
    } else if (topOffset < this.previousScroll) {
      this.header.addClass('sticky');
      // Additional checking so the header will not flicker
      if (topOffset > 250) {
        this.header.addClass('sticky');
      } else {
        this.header.removeClass('sticky');
      }
    }

    this.previousScroll = topOffset;
    this.gotoTop.toggleClass(
      'active',
      this.window.scrollTop() > this.screenHeight / 2,
    );
  };

  handleSplashScreen() {
    //this.htmlBody.find('.logo-middle').fadeIn(500);
    //this.siteLoader.delay(1500).fadeOut(500);
  }

  handleTableScroll() {

    $('.table-nav-buttons .right').on('click', () => {
      let leftPos = $('.table-wrapper, .mobile-table-wrap').scrollLeft();
      $(".table-wrapper, .mobile-table-wrap").animate({
        scrollLeft: leftPos + 200
      }, 300);
    });

    $('.table-nav-buttons .left').on('click', () => {
      let leftPos = $('.table-wrapper, .mobile-table-wrap').scrollLeft();
      $(".table-wrapper, .mobile-table-wrap").animate({
        scrollLeft: leftPos - 200
      }, 300);
    });

    var scrollLeftPrev = 0;
    $('.table-wrapper, .mobile-table-wrap').on('scroll', () => {
      let $elem=$('.table-wrapper, .mobile-table-wrap');
      var newScrollLeft = $elem.scrollLeft(),
          width=$elem.outerWidth(),
          scrollWidth=$elem.get(0).scrollWidth;
      if (scrollWidth-newScrollLeft==width) {
        $('.table-nav-buttons .right').addClass('disabled');
      } else {
        $('.table-nav-buttons .right').removeClass('disabled');
      }
      if (newScrollLeft === 0) {
        $('.table-nav-buttons .left').addClass('disabled');
      } else {
        $('.table-nav-buttons .left').removeClass('disabled');
      }
      scrollLeftPrev = newScrollLeft;
    });

  }

  allTableScroll() {

    $( ".mobile-table-wrap" ).each(( index , e) => {
      let $this = $(e);
      $this.attr("data-navid",index);
      $(`
       <div class="table-nav-buttons" data-navid="${index}">
          <div class="left"><i class="icon-left-arrow"></i></div>
          <div class="right"><i class="icon-right-arrow"></i></div>
       </div>
      `).insertBefore($this);


      $('.table-nav-buttons[data-navid="'+index+'"] .right').on('click', () => {
        let leftPos = $('.mobile-table-wrap[data-navid="'+index+'"]').scrollLeft();
        console.log("clicked");
        $('.mobile-table-wrap[data-navid="'+index+'"]').animate({
          scrollLeft: leftPos + 200
        }, 300);
      });

      $('.table-nav-buttons[data-navid="'+index+'"] .left').on('click', () => {
        let leftPos = $('.mobile-table-wrap[data-navid="'+index+'"]').scrollLeft();
        console.log("clicked lfe");
        $('.mobile-table-wrap[data-navid="'+index+'"]').animate({
          scrollLeft: leftPos - 200
        }, 300);
      });

      var scrollLeftPrev = 0;
      $('.mobile-table-wrap[data-navid="'+index+'"]').on('scroll', () => {
        let $elem=$('.mobile-table-wrap[data-navid="'+index+'"]');
        var newScrollLeft = $elem.scrollLeft(),
            width=$elem.outerWidth(),
            scrollWidth=$elem.get(0).scrollWidth;
        if (scrollWidth-newScrollLeft==width) {
          $('.table-nav-buttons[data-navid="'+index+'"] .right').addClass('disabled');
        } else {
          $('.table-nav-buttons[data-navid="'+index+'"] .right').removeClass('disabled');
        }
        if (newScrollLeft === 0) {
          $('.table-nav-buttons[data-navid="'+index+'"] .left').addClass('disabled');
        } else {
          $('.table-nav-buttons[data-navid="'+index+'"] .left').removeClass('disabled');
        }
        scrollLeftPrev = newScrollLeft;
      });
    });
  }

  handleUserAgent = () => {
    // detect mobile platform
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      this.htmlBody.addClass('ios-device');
    }
    if (navigator.userAgent.match(/Android/i)) {
      this.htmlBody.addClass('android-device');
    }

    // detect desktop platform
    if (navigator.appVersion.indexOf('Win') !== -1) {
      this.htmlBody.addClass('win-os');
    }
    if (navigator.appVersion.indexOf('Mac') !== -1) {
      this.htmlBody.addClass('mac-os');
    }

    // detect IE 10 and 11P
    if (
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      navigator.appVersion.indexOf('Trident/') > 0
    ) {
      this.html.addClass('ie10');
    }

    // detect IE Edge
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      this.html.addClass('ieEdge');
    }

    // Specifically for IE8 (for replacing svg with png images)
    if (this.html.hasClass('ie8')) {
      const imgPath = '/themes/theedge/images/';
      $('header .logo a img,.loading-screen img').attr(
        'src',
        `${imgPath}logo.png`,
      );
    }

    // show ie overlay popup for incompatible browser
    if (this.html.hasClass('ie9')) {
      const message = $(
        '<div class="no-support"> You are using outdated browser. Please <a href="https://browsehappy.com/" target="_blank">update</a> your browser or <a href="https://browsehappy.com/" target="_blank">install</a> modern browser like Google Chrome or Firefox.<div>',
      );
      this.htmlBody.prepend(message);
    }
  };



  handleRulesTabs = () => {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      if ($('.panel-body .tab-pane#agendas').hasClass('active') ){
        $('.nav-tabs li').removeClass('active');
        $('.nav-tabs .agenda-tab').addClass('active');
      }
      if ($('.panel-body .tab-pane#minutes').hasClass('active') ){
        $('.nav-tabs li').removeClass('active');
        $('.nav-tabs .minutes-tab').addClass('active');
      }
    })
  }
  

   // left right submneu content display
  leftRightcontentBlock = () => {
    let rightContentBlock = $(".rel_left_content");
    let spl_ul_li = $(".special_ul li");
    let faq = $(".faq");
    let question =   $(".faq__question");
    let answer =  $(".faq__answer");

    if($(".special_ul").hasClass('sidebar_wt_accordion')){

      spl_ul_li.removeClass('active');
      $('.special_ul >li').on('click', function (e) {
        if($(this).hasClass('active')){
          return;
        }
        $('.special_ul >li').css('pointer-events', 'none');
        spl_ul_li.removeClass('active');
        faq.removeClass("active");
        answer.slideUp("slow");
        var id_val = $(this).attr('id_val');
        setTimeout(function () {
          $('.rel_left_'+id_val + ' .faq').addClass("active").find(".faq__answer").slideDown("slow");
          $('#rel_right_'+id_val).addClass("active");
          $('.special_ul >li').css('pointer-events', 'auto');
        },1000);

        if($(window).width()  < 768){
          setTimeout(function () {
            $('html,body').animate({scrollTop: $('.rel_left_'+id_val).offset().top});
          },800);
        }
      });

    }else{
      $('.special_ul >li').on('click', function (e) {
        
        if($(this).hasClass('active')){
          return;
        }

        $('.special_ul >li').css('pointer-events', 'none');

        spl_ul_li.removeClass('active');
        rightContentBlock.fadeOut("slow");
        var id_val = $(this).attr('id_val');
        setTimeout(function () {
          $('.rel_left_'+id_val).fadeIn("slow")
          $('.rel_left_'+id_val).addClass("active")
          $('#rel_right_'+id_val).addClass("active")
          $('.special_ul >li').css('pointer-events', 'auto');
        },1000);

        if($(window).width()  < 768){
          setTimeout(function () {
            $('html,body').animate({scrollTop: $('.rel_left_'+id_val).offset().top});
             
          },800);
        }
      });
    }
  }

  // checkbox click change event
  checkBoxEvent=()=>{
    $('input[type=checkbox]').on('change', function (e) {
      if (this.checked) {
        $(this).parent().addClass('selected');
      }else{
        $(this).parent().removeClass('selected');
      }
    }) 
  }

  selectUaeEvent=()=>{
    $('select[id*="location"]').on('change', function (e) {
      if ($(this).val() == "United Arab Emirates") {
        $('div[class*="emirate"]').show();
      }else{
        $('div[class*="emirate"]').hide();
      }
    })
  }


  // show emirates when 
  /*$( ".target" ).change(function() {
  alert( "Handler for .change() called." );
});*/

})();

document.addEventListener("DOMContentLoaded", function() {
  var timer;
  var delay = 300;
  $("header .menu-links li.has-sub-nav").hover(
      function () {
        var $navItem = $(this);
        var sector = $(this).data("value");
        $navItem.addClass('opened');
        timer = setTimeout(function() {
          $(".sub-nav-wrap .sub-nav").each(function () {
            var vSector = $(this).data("value");
            if (vSector.indexOf(sector) != -1) {
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });
          $(".menu-overlay").addClass('open');
          $("body").addClass('no-scroll');
          setTimeout(function () {
            $("header").addClass('menu-opened');}, 400);
        }, delay);

      },
      function () {
        clearTimeout(timer);
      }
  );

  $(".hide-nav").hover(function () {
    setTimeout(function () {
      $(".sub-nav").removeClass('active');
      $(".menu-overlay").removeClass('open');
      $("body").removeClass('no-scroll');
      setTimeout(function () {
        $("header").removeClass('menu-opened');
      }, 400);
    }, delay);
  });


  // Enquiry Page

  $(".main-option-row").show();
  $(".wills-option-row .info:first-child").addClass("active");


  var enquiryRow = $(".enquiry-row");
  var selectionBlock = $(".selection-block");
  var footerNavFixed =   $(".nav-footer.fixed");

  $(".main-option-row a").click(function() {
    var sector = $(this).data("value");
    $(this).addClass("active");
    enquiryRow.fadeOut("slow");
     if($(this).hasClass("wills-link")){
        setTimeout(function () {
          footerNavFixed.fadeIn("slow");
          $(".nav-footer.fixed .back").addClass("back-to-step-one");
        },1000);
      }
      if($(this).hasClass("courts-link")){
        setTimeout(function () {
          $(".courts-option-row .nav-footer .back").addClass("back-to-step-one");
          $(".courts-option-row .wrap").addClass("active");
        },1000);
      }
    setTimeout(function () {
      enquiryRow.each(function () {
        var vSector = $(this).data("value");
        if (vSector.indexOf(sector) != -1) {
          $(this).fadeIn("slow");
        } else {
          $(this).fadeOut("slow");
        }
      });
    },1000);
  });

  $(document).on("click",".back-to-step-one",function() {
    enquiryRow.fadeOut("slow");
    footerNavFixed.fadeOut("slow");
    $(".nav-footer.fixed .back").removeClass("back-to-step-one");
    $(".courts-option-row .wrap").removeClass("active");
    setTimeout(function () {
      $(".main-option-row").fadeIn("slow");
    },1000);
  });



  $(document).on("click",".sitemap_autonav ul li a",function(e) {
    e.preventDefault();
    var urlPath = $(this).attr('href');
    if($(this).siblings('ul').css('display')=='none'){
        $(this).siblings('ul').slideDown();
        $(this).parent().siblings('li').find('ul').slideUp();
    }else{
      window.location.href = urlPath;
    }
  });





  


  var hoverTimer;
  var hoverDelay = 600;
  $(".full-will-option-row a").hover(
      function () {
        var sector = $(this).data("value");
        hoverTimer = setTimeout(function() {
          $(".wills-option-row .info").each(function () {
            var vSector = $(this).data("value");
            if (vSector.indexOf(sector) != -1) {
              //$(this).fadeIn("slow");
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });
        },hoverDelay);
      },
      function () {
        clearTimeout(hoverTimer);
        setTimeout(function() {
          $(".wills-option-row .info").removeClass("active");
          $(".wills-option-row .info:first-child").addClass("active");
        },hoverDelay);
      }
  );



  $(document).on("click",".full-will-option-row a",function() {
    selectionBlock.fadeOut("slow");
    footerNavFixed.fadeOut("slow");
    var pointIndex = $(this).index();
    var stepBlock = $(".step-block-wrap");
    var stepBlockContainerWrap =  $(".step-block-wrap .container .wrap");
    var stepBlockContainerWrapSteps = $(".step-block-wrap .container .wrap .steps");
    setTimeout(function () {
      stepBlock.fadeIn("slow");
      stepBlockContainerWrap.eq(pointIndex).fadeIn("slow").siblings().fadeOut("slow");
      stepBlockContainerWrap.eq(pointIndex).addClass("active").siblings().removeClass("active");
      stepBlockContainerWrapSteps.removeClass("active");
      stepBlockContainerWrapSteps.eq(pointIndex).addClass("active").siblings().removeClass("active");
      //$(".step-block-wrap .container .wrap.active .steps-item").eq(pointIndex).fadeIn("slow").siblings().fadeOut("slow");
    },1000);
  });

  $(document).on("click",".full-will-option-row a:first-child",function() {
    $(".wills-step-block-wrap .nav-footer .continue").addClass("show");
  });

  $(document).on("click",".wrap.active .steps-item.active .row a",function() {
    if(!$(this).hasClass("external")){
      var pointIndex =  $(".wrap.active .steps-item.active").index();
      $(this).closest(".steps-item").find("a").removeClass("active").find(".primary-btn").html("Select");
      $(this).addClass("active").find(".primary-btn").html("Selected");
      $(".wrap.active .steps li").eq(pointIndex + 1).addClass("active");
      $(".wrap.active .steps-item").fadeOut("slow");
      $(".wrap.active .steps-item").eq(pointIndex + 1).addClass("active").siblings().removeClass("active");
      setTimeout(function () {
        $(".wrap.active .steps-item").eq(pointIndex + 1).fadeIn("slow");
      },1000);
      if($(".wrap.active .steps-item:last-child").hasClass("active")){
        $(".nav-footer .continue").fadeIn("slow");
      }else{
        $(".nav-footer .continue").fadeOut("slow");
      }
      $(".wills-form-block .nav-footer .container .back").fadeIn("slow");
    }
  });

  $(document).on("click",".nav-footer .continue",function() {
    var stepOneTitle = $(".wrap.active .step-one .active span").text();
    var stepTwoTitle = $(".wrap.active .step-two .active span").text();
    var stepThreeTitle = $(".wrap.active .step-three .active span").text();
    $(".wrap.active input[id^='step-one']").val(stepOneTitle);
    $(".wrap.active input[id^='step-two']").val(stepTwoTitle);
    $(".wrap.active input[id^='step-three']").val(stepThreeTitle);
    setTimeout(function () {
      $(".wrap.active .ccm-input-submit").click();
    },500);

  });

  $(document).on("click",".enquiry-block.no-step .continue",function() {
    $(".enquiry-block.no-step .ccm-input-submit").click();
  });



  $(document).on("click",".step-block-wrap .back",function() {
    if($(".step-block-wrap .wrap.active .step-one.active").length){
      $(".nav-footer .continue").fadeOut("slow");
      $(".step-block-wrap,.step-block-wrap .wrap").fadeOut("slow");
      enquiryRow.fadeOut("slow");
      setTimeout(function () {
        selectionBlock.fadeIn("slow");
        $(".wills-option-row").fadeIn("slow");
        footerNavFixed.fadeIn("slow");
      },1000);
    }else{
      $(".nav-footer .continue").fadeOut("slow");
      var pointIndex =  $(".wrap.active .steps-item.active").index();
      $(".wrap.active .steps li").eq(pointIndex).removeClass("active");
      $(".wrap.active .steps-item").fadeOut("slow");
      $(".wrap.active .steps-item ").eq(pointIndex - 1).addClass("active").siblings().removeClass("active");
      setTimeout(function () {
        $(".wrap.active .steps-item").eq(pointIndex - 1).fadeIn("slow");
      },1000);
    }
    $(".wills-step-block-wrap .nav-footer .continue").removeClass("show");
    if($(".wills-form-block .step-block-wrap .wrap.active .step-one.active").length){
      $(".wills-form-block .nav-footer .container .back").fadeOut("slow");
    }
  });

  // wills probate

setTimeout(function(){
  $('.page-type-wills-probate #ff_buttons input').addClass('primary-btn');
}, 100)
  

  // Enquiry Page Ends

  $(".radio").closest(".element").addClass("radio-block");
  $(".radio:first-child label").addClass("radio_selected");

  $(".radio input").on('change', function(){
    $(this).parent().parent().parent().find('label').removeClass('radio_selected');
    $(this).parent().addClass('radio_selected');
  });

});


window.addEventListener('load', function() {


  let wrapper =   $(".wrapper");
  if($(".site-loader.active").length){
    setTimeout(function () {
      setTimeout(function () {
        setTimeout(function () {
          wrapper.addClass("active");
          sliders();
        },400);
        animations();
      },1300);
    },1200);
  }else{
    setTimeout(function () {
      wrapper.addClass("active");
      sliders();
    },400);
    animations();
  }



  if($('select').length) {
    $('select').chosen({});
    $('select').parent().find('b').addClass('icon-down-arrow');
  }

  if($('.element .chosen-container').length) {
      console.log("fdfd");
    $('.element .chosen-container').closest(".element").addClass("active");
  }
  

  // 
  if( $(window).width()  < 768){
    $('.search_result .nav-tabs').on("click", "li:not('.active') a", function(event) {  
      $(this).closest('ul').removeClass("open");
    }).on("click", "li.active a", function(event) {        
      $(this).closest('ul').toggleClass("open");
    });
  }


  // fancybox-open on click

  /*$('.image_set a').fancybox({
    // Options will go here
    margin : [44,0,22,0],
    thumbs : {
      autoStart : true,
      axis      : 'x'
    },
    buttons : false,
    afterLoad : function( instance, current ) {
      if ( instance.group.length > 1 && current.$content ) {
        current.$content.append('<a data-fancybox-next class="button-next" href="javascript:;">→</a><a data-fancybox-previous class="button-previous" href="javascript:;">←</a>');
      }
      
      current.$content.append('<a data-fancybox-close class="button-close" href="javascript:;">×</a>');
    }
  });
  */


  /*if (sessionStorage.getItem('reloaded') != null) {
    alert()
    $.fancybox.close();
  }*/
  
  $('.img_gallery').on("click", function() {  
    var caption = '';
    $(this).find('.image_set p').fancybox({
      margin        : [44,0,22,0],
      thumbs        : {
        autoStart   : true,
        axis        : 'x'
      },
      loop          : true,
      infobar       : false,
      buttons       : false,
      caption       : function( instance, item ) {
                      caption = $(this).data('caption') || '';
      },
      afterLoad     : function( instance, current ) {
                      if ( instance.group.length > 1 && current.$content ) {
                        current.$content.append('<a data-fancybox-next class="button_next" href="javascript:;"></a><a data-fancybox-prev class="button_prev" href="javascript:;"></a>');
                      }
                      //current.$content.append('');
                      current.$content.prepend('<div class="caption"><h6>'+ caption + '</h6><p><span data-fancybox-index>'+(this.index + 1)+'</span>/<span data-fancybox-count>'+ instance.group.length+'</span></p> <a data-fancybox-close class="button_close" href="javascript:;"></a></div>');
      }
    }).trigger('click');
  });

  $('[data-fancybox]').fancybox({
    afterLoad : function( instance, current ) {
        current.$content.append('<a data-fancybox-close class="button_close" href="javascript:;"></a>');
      }
  });




  $('.popup-img-wrapper').fancybox({
    baseClass: "pop-up-wrapper",
  });




// wills draftman assign draftman name to form open  modal


var draftman_contact = $(".cta");

  draftman_contact.click(function(){
    var draftman_name = $(this).parent().parent().find("td:first-child").text();
    var draftman_email = $(this).parent().parent().find("#draftsmanemail").text();
    $('[id^=draftsman]').val(draftman_name);
    $('[id^=draftsemail]').attr('value', draftman_email);
  });


  function animations(){
    TweenMax.from(".banner", 2, {
      force3D: !0,
      scale: 1.3,
      ease: Circ.easeOut
    });

    TweenMax.from("header .logo img", 0.8, {
      delay: 0.8,
      opacity: 0,
      force3D: !0,
      y: "60",
      ease: Power1.easeInOut
    });

    TweenMax.from(".mobile-menu", 0.8, {
      delay: 1.4,
      opacity: 0,
      force3D: !0,
      y: "20",
      ease: Power1.easeInOut
    });

    TweenMax.staggerFrom("header .nav>li>a", 0.8, {
      delay: 0.8,
      opacity: 0,
      y: 40,
      ease: Expo.easeInOut
    }, 0.2);

    TweenMax.from("header .btn-wrap .icon-search-icon", 0.8, {
      delay: 0.6,
      opacity: 0,
      force3D: !0,
      y: "20",
      ease: Power1.easeInOut
    });

    TweenMax.from("header .btn-wrap .primary-btn", 0.8, {
      delay: 0.8,
      opacity: 0,
      force3D: !0,
      y: "20",
      ease: Power1.easeInOut
    });

    TweenMax.from(".caption-search-block .container .content h1", 0.8, {
      delay: 1,
      opacity: 0,
      force3D: !0,
      x: "-40",
      ease: Power1.easeInOut
    });

    TweenMax.from(".caption-search-block .container .content a", 0.8, {
      delay: 1,
      opacity: 0,
      force3D: !0,
      x: "-40",
      ease: Power1.easeInOut,
      clearProps:"all"
    });

    TweenMax.from(".caption-search-block .container .search", 0.8, {
      delay: 1,
      opacity: 0,
      force3D: !0,
      x: "40",
      ease: Power1.easeInOut
    });

    TweenMax.staggerFrom(".banner-block .page-list li a", 0.8, {
      delay: 0.8,
      opacity: 0,
      y: "50",
      ease: Expo.easeInOut
    }, 0.2);

    if($(".inner-banner").length){
      TweenMax.from(".caption .breadcrumb", 0.8, {
        delay: 1,
        opacity: 0,
        force3D: !0,
        x: "-40",
        ease: Power1.easeInOut
      });

      TweenMax.from(".caption h1", 0.8, {
        delay: 1.2,
        opacity: 0,
        force3D: !0,
        x: "-40",
        ease: Power1.easeInOut
      });
    }

  }


  function sliders(){

    let homeBannerSlider = new Swiper('.banner-slider', {
      direction: 'vertical',
      speed: 1000,
      effect: 'fade',
      watchOverflow: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    homeBannerSlider.on('transitionStart', function () {
      const bg = document.querySelectorAll('.lazy-background');
      var bgObserver = lozad(bg, {
        loaded: function(el) {
          el.classList.add('reveal')
        },
        threshold: 0,
      });
      bgObserver.observe()
    });

    var courtsSlider = document.querySelector('.courts-slider');
    var courtSwiper = new Swiper (courtsSlider, {
      direction: 'horizontal',
      slidesPerView: 4,
      grabCursor: true,
      freeMode: true,
      loop: true,
      speed:800,
      spaceBetween: 20,
      navigation: {
        nextEl: '.services.courts .swiper-button-next',
        prevEl: '.services.courts .swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      }
    });

    courtSwiper.on('transitionStart', function () {
      const bg = document.querySelectorAll('.lazy-background');
      var bgObserver = lozad(bg, {
        loaded: function(el) {
          el.classList.add('reveal')
        },
        threshold: 0,
      });
      bgObserver.observe()
    });

    var willsSlider = document.querySelector('.wills-slider');
    var willsSwiper = new Swiper (willsSlider, {
      direction: 'horizontal',
      slidesPerView: 4,
      grabCursor: true,
      freeMode: true,
      loop: true,
      speed:800,
      spaceBetween: 20,
      navigation: {
        nextEl: '.services.wills .swiper-button-next',
        prevEl: '.services.wills .swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      }
    });

    willsSwiper.on('transitionStart', function () {
      const bg = document.querySelectorAll('.lazy-background');
      var bgObserver = lozad(bg, {
        loaded: function(el) {
          el.classList.add('reveal')
        },
        threshold: 0,
      });
      bgObserver.observe()
    });



    
    var arbitration_suite_slider = document.querySelector('.content_as_gallery');
    if(arbitration_suite_slider){
      var arbitration_suite_slider_swiper = new Swiper (arbitration_suite_slider, {
        direction: 'horizontal',
        slidesPerView: 1,
        grabCursor: true,
        freeMode: true,
        loop: true,
        speed:800,
        spaceBetween: 0,
        navigation: {
          nextEl: '.content_as_gallery .swiper-button-next',
          prevEl: '.content_as_gallery .swiper-button-prev',
        },
      });

      /*arbitration_suite_slider.on('transitionStart', function () {
        const bg = document.querySelectorAll('.lazy-background');
        var bgObserver = lozad(bg, {
          loaded: function(el) {
            el.classList.add('reveal')
          },
          threshold: 0,
        });
        bgObserver.observe()
      });*/
    }
    

    if ($(window).width()  <= 768) {
      var arbitration_suite_icon = $('.content_as_icon_block');
      if(arbitration_suite_icon){
        arbitration_suite_icon.each(function(index){
          var arbitration_suite_icon_swiper = new Swiper (arbitration_suite_icon, {
            direction: 'horizontal',
            slidesPerView: 3,
            grabCursor: false,
            freeMode: false,
            loop: false,
            spaceBetween: 0,
            breakpoints: {
              640: {
                slidesPerView: 2,
              },
              320: {
                slidesPerView: 2,
              },
            }
          });
        });
        

        /*arbitration_suite_icon.on('transitionStart', function () {
          const bg = document.querySelectorAll('.lazy-background');
          var bgObserver = lozad(bg, {
            loaded: function(el) {
              el.classList.add('reveal')
            },
            threshold: 0,
          });
          bgObserver.observe()
        });*/
      }
    }




    if ($(window).width()  <= 768) {
      let medialist_slider = document.querySelector('.media_list');
      const medialist_swiper = new Swiper(medialist_slider, {
        direction: 'horizontal',
        slidesPerView: 5,
        grabCursor: true,
        freeMode: true,
        loop: false,
        speed:800,
        spaceBetween: 40,
        breakpoints: {
          767: {
            slidesPerView: 4,
          },
          500: {
            slidesPerView: 3,
          },
          450: {
            slidesPerView: 2,
          },
        }
      });
    }


    if ($(window).width()  < 767) {

      var bannerLinks = document.querySelector('.banner-links');
      var bannerSwiper = new Swiper (bannerLinks, {
        direction: 'horizontal',
        slidesPerView: 5,
        grabCursor: true,
        freeMode: true,
        speed:800,
        spaceBetween: 0,
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          640: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 2,
          },
        }
      });

    }

    var banklogo = document.querySelector('.image_slider');
    var banklogoSwiper = new Swiper (banklogo, {
        direction: 'horizontal',
        slidesPerView: 5,
        grabCursor: true,
        freeMode: true,
        speed:800,
        loop: true,
        spaceBetween: 0,
        breakpoints: {
          
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          320: {
            slidesPerView: 2,
          },
        }
      });


  }


  // Initialize library to lazy load images
  var observer = lozad('.lazy', {
    threshold: 0,
    rootMargin: '150px 0px'
  })

  const el = document.querySelectorAll('img');
  const observerImg = lozad(el,{
    rootMargin: '200px 0px'
  }); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid
  observer.observe();


  // Background observer
  // with default `load` method
  const bgImage = document.querySelectorAll('.lazy-background');
  var backgroundObserver = lozad(bgImage, {
    loaded: function(el) {
      el.classList.add('reveal')
    },
    threshold: 0,
    rootMargin: '200px 0px'
  });


  observer.observe()
  observerImg.observe();
  backgroundObserver.observe()




  setTimeout(function () {
    if(!$(".banner-wrap").length){
      $("header").addClass("white");
    }
  },500);


  var fadeLeftTo = lozad('.fade-left-to', {
    threshold: 0,
    loaded: function(el) {
      el.classList.add('loaded');
      var animateFadeLeftTo = new TimelineMax();
      animateFadeLeftTo.to( el, 1, {
        opacity: 1,
        x: "0",
        ease: Power1.easeInOut,
      });
    }
  });

  fadeLeftTo.observe();


  var fadeIn = lozad('.fade-in', {
    threshold: 0,
    loaded: function(el) {
      el.classList.add('loaded');
      var animateFadeIn = new TimelineMax();
      animateFadeIn.to( el, 1, {
        opacity: 1,
        ease: Power1.easeInOut,
      });
    }
  });

  fadeIn.observe();


  var fadeInDelay800 = lozad('.fade-in-800', {
    threshold: 0,
    loaded: function(el) {
      el.classList.add('loaded');
      var animateFadeIn800 = new TimelineMax();
      animateFadeIn800.to( el, 1, {
        delay:0.8,
        opacity: 1,
        ease: Power1.easeInOut,
      });
    }
  });

  fadeInDelay800.observe();





  var animate = lozad('.animate', {
    threshold: 0,
    loaded: function(el) {
      // Custom implementation on a loaded element
      el.classList.add('loaded');
      //el.children("h2");
      //var heading = $(this).find("h2");
      //console.log(el.children);
      var animateFadeLeft = new TimelineMax();
      var animateFadeLeft200 = new TimelineMax();
      var animateScale = new TimelineMax();
      var animateScaleTo = new TimelineMax();
      var animateScaleDelay800 = new TimelineMax();
      var animateUp = new TimelineMax();
      var animateLeft = new TimelineMax();
      var animateWidthScale = new TimelineMax();
      var animateHeightScale = new TimelineMax();
      var animateWidthRight = new TimelineMax();
      var animateHeightStagger  = new TimelineMax();

      animateFadeLeft.from( el.querySelectorAll(".fade-left"), 1, {
        opacity: 0,
        x: "-40",
        ease: Power1.easeInOut,
      });
      animateScale.from( el.querySelectorAll(".scale"), 1, {
        force3D: !0,
        scale: 1.3,
        ease: Power1.easeOut
      });
      animateScaleTo.to( el.querySelectorAll(".scale-to"), 1, {
        force3D: !0,
        scale: 1,
        ease: Power1.easeOut
      });
      animateScaleDelay800.to( el.querySelectorAll(".scale-delay-800"), 1, {
        delay:0.8,
        force3D: !0,
        scale: 1,
        ease: Circ.easeOut
      });
      animateFadeLeft200.from( el.querySelectorAll(".fade-left-200"), 1, {
        delay:0.2,
        opacity: 0,
        x: "-40",
        ease: Power1.easeInOut,
      });
      animateWidthScale.to( el.querySelectorAll(".width"), 1, {
        width: "100%",
        ease: Power2.easeInOut
      });
      animateHeightScale.to( el.querySelectorAll(".height"),1, {
        height: 0,
        ease: Power2.easeInOut
      });
      animateWidthRight.to( el.querySelectorAll(".width-right"),1, {
        css: {
          right: "-100%"
        }
      });
      animateUp.staggerFrom( el.querySelectorAll(".stagger-up"), 0.8, {
        opacity: 0,
        y: "60",
        ease: Power1.easeInOut,
      }, 0.2);
      animateLeft.staggerFrom( el.querySelectorAll(".stagger-left"), 1, {
        opacity: 0,
        x: "-60",
        ease: Power1.easeInOut,
      }, 0.2);

      animateHeightStagger.to( el.querySelectorAll(".height-stagger"),1, {
        height: 0,
        ease: Power2.easeInOut
      }, 0.2);

      var imageOverlay = el.querySelectorAll(".image-content-block .image-overlay");
      var image = el.querySelectorAll(".image-content-block .image");
      var contentBlock =  el.querySelectorAll(".image-content-block .content");
      var contentHeading =  el.querySelectorAll(".image-content-block .content h2");
      var contentDesc =  el.querySelectorAll(".image-content-block .content p");
      var contentButton =  el.querySelectorAll(".image-content-block .content .primary-btn");
      if($(".image-content-block").length){
        var imageBlockAnim = new TimelineMax().to(imageOverlay,1, {
          delay:0.4,
          css: {
            right: "-100%"
          }
        }).to(image, 1, {
          force3D: !0,
          scale: 1,
          ease: Circ.easeOut
        }, "-=1").from(contentBlock, 0.8, {
          delay:0.1,
          opacity: 0,
          y: "80",
          ease: Power1.easeInOut
        }, "-=0.8").from(contentHeading, 0.8, {
          delay:0.2,
          opacity: 0,
          y: "40",
          ease: Power1.easeInOut
        }, "-=0.8").from(contentDesc, 0.8, {
          delay:0.3,
          opacity: 0,
          y: "40",
          ease: Power1.easeInOut
        }, "-=0.8").from(contentButton, 0.8, {
          delay:0.4,
          opacity: 0,
          y: "40",
          ease: Power1.easeInOut
        }, "-=0.8");
      }


    }
  })

  animate.observe()


  //open submenu for mobile devices
  if($(window).width() < 1200) {
    $(".mobile-menu-block .nav-drop").click(function(){
      if(!$(this).hasClass("clicked")){
        $(".mobile-menu-block .nav-drop").removeClass("clicked");
        $(this).addClass("clicked");
        return false;
      }
    });

    $(".mobile-menu-block.chinese-mob-menu a").click(function(){
      $(".mobile-menu-block").removeClass("open");
      $(".menu-btn").removeClass("open");
    });
  }



  // Accordion
  var question =   $(".faq__question");
  var answer =  $(".faq__answer");
  var faq = $(".faq");

  question.click(function(){
    if(!$(this).parent().hasClass("active")){
      answer.slideUp("slow");
      faq.removeClass("active");
      $('.special_ul.sidebar_wt_accordion li').removeClass('active');
      $(this).parent().addClass("active").find(".faq__answer").slideDown("slow");
      var item_id = $(this).parent().parent().parent().attr('item_id');
      $('.special_ul.sidebar_wt_accordion #rel_right_'+item_id).addClass('active');
    }else{
      $(this).parent().removeClass("active").find(".faq__answer").slideUp("slow");
      $('.special_ul.sidebar_wt_accordion li').removeClass('active');
    }
  });


  var booking_enquiry =   $(".booking_enquiry");
  booking_enquiry.click(function(){
    $('.booking_form').slideDown()
  });

  // Accordion Ends


});
